module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "metrics-banner"
  }, _vm._l((_vm.metricsArray), function(metric) {
    return _c('div', {
      staticClass: "metrics-banner__metric"
    }, [_c('svg-icon', {
      staticClass: "metrics-banner__icon",
      attrs: {
        "icon": metric.icon
      }
    }), _vm._v(" "), (_vm.loading) ? _c('span', {
      staticClass: "metrics-banner__loading"
    }, [_vm._v("…")]) : _c('span', [_vm._v(_vm._s(metric.text))])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b6526d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/workbenchToolbar/MetricsBanner.vue
// module id = 1979
// module chunks = 0